import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../services/api";

export default function ArchivedTendersPage() {
  const [tenders, setTenders] = useState([]);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get("/tenders/")
      .then(res => {
        // ✅ фильтруем архив и сортируем по last_done_date ↓
        const archived = res.data
          .filter(t => t.status === "archived")
          .sort((a, b) => {
            const da = a.last_done_date ? new Date(a.last_done_date) : 0;
            const db = b.last_done_date ? new Date(b.last_done_date) : 0;
            return db - da; // по убыванию
          });
        setTenders(archived);
      })
      .catch(err => {
        console.error(err);
        setError("Ошибка при загрузке тендеров");
      });
  }, []);

  return (
    <div className="p-6">
      <div className="flex justify-start mb-6">
        <button
          onClick={() => navigate("/")}
          className="bg-gray-300 px-4 py-2 rounded hover:bg-gray-400"
        >
          ⬅️ Назад
        </button>
      </div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Архивные тендеры</h1>
      </div>

      {error && <p className="text-red-600">{error}</p>}
      <TenderTable tenders={tenders} />
    </div>
  );
}

function TenderTable({ tenders }) {
  const navigate = useNavigate();

  if (tenders.length === 0) {
    return <p className="text-gray-600">Нет архивных тендеров.</p>;
  }

  return (
    <div className="overflow-x-auto">
      <table className="min-w-full border-collapse table-auto">
        <thead>
          <tr className="bg-gray-100 text-left">
            <th className="p-2 w-12">№</th>
            <th className="p-2">Номер</th>
            <th className="p-2">Заказчик</th>
            <th className="p-2">Наименование</th>
            <th className="p-2">Сумма заявки</th>
            <th className="p-2">Исполнитель</th>
            <th className="p-2">Обновлено</th>
          </tr>
        </thead>
        <tbody>
          {tenders.map((t, index) => (
            <tr
              key={t.id}
              onClick={() => navigate(`/tenders/${t.id}`)}
              className="border-t hover:bg-gray-100 cursor-pointer"
            >
              <td className="p-2">{index + 1}</td>
              <td className="p-2">{t.number}</td>
              <td className="p-2">{t.customer}</td>
              <td className="p-2">{t.title}</td>
              <td className="p-2">
                {t.bid_amount != null
                  ? parseFloat(t.bid_amount).toLocaleString("ru-RU", {
                      style: "currency",
                      currency: "RUB",
                    })
                  : "—"}
              </td>
              <td className="p-2">{t.executor?.full_name || "—"}</td>
              <td className="p-2">
                {new Date(t.updated_at).toLocaleDateString()}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}